import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import './SearchBar.css';

const SearchBar = ({ apiBaseUrl }) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    if (!query) {
      setSuggestions([]);
      setShowSuggestions(false);
      setActiveIndex(-1);
      return;
    }
    fetch(`${apiBaseUrl}/search_suggestions?q=${encodeURIComponent(query)}`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        setSuggestions(data);
        setShowSuggestions(data.length > 0);
        setActiveIndex(-1);
      })
      .catch(err => console.error('Error fetching suggestions:', err));
  }, [query, apiBaseUrl]);

  const goToSearchPage = () => {
    const trimmed = query.trim();
    if (!trimmed) return;
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  const goToSuggestion = (item) => {
    navigate(`/media-item/${item.id}`);
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || suggestions.length === 0) {
      if (e.key === 'Enter') {
        e.preventDefault();
        goToSearchPage();
      }
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex((prev) => (prev + 1) % suggestions.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex((prev) => (prev <= 0 ? suggestions.length - 1 : prev - 1));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && activeIndex < suggestions.length) {
        goToSuggestion(suggestions[activeIndex]);
      } else {
        goToSearchPage();
      }
    } else if (e.key === 'Escape') {
      setShowSuggestions(false);
      setActiveIndex(-1);
    }
  };

  useEffect(() => {
    if (activeIndex >= 0 && itemRefs.current[activeIndex]) {
      itemRefs.current[activeIndex].scrollIntoView({ block: 'nearest' });
    }
  }, [activeIndex]);

  const typeIcons = {
    SteamGame: '/static/icons/steam.svg',
    Anime: '/static/icons/clapperboard-solid.svg',
    Manga: '/static/icons/book-solid.svg',
    Book: '/static/icons/book-solid.svg',
    PhysicalGame: '/static/icons/gamepad-solid.svg',
    Music: '/static/icons/compact-disc-solid.svg',
    ScreenMedia: '/static/icons/film-solid.svg',

  };

  return (
    <div className="search-section">
      <h2>Quick Search</h2>
      <div className="search-input-wrapper">
        <input
          ref={inputRef}
          type="text"
          id="global-search"
          placeholder="Search across all media..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <img src="/static/icons/magnifying-glass-solid.svg" className="search-icon icon" alt="Search" />
        {query && (
          <button
            type="button"
            className="search-go-btn"
            onClick={goToSearchPage}
            aria-label="Search"
            tabIndex={-1}
          >
            <img src="/static/icons/arrow-right-solid.svg" className="icon" alt="Go" />
          </button>
        )}
        {showSuggestions && (
          <div className="search-suggestions">
            {suggestions.map((item, index) => (
              <a
                key={`${item.type}-${item.title}`}
                ref={(el) => (itemRefs.current[index] = el)}
                // href={`/media-list/${item.type}#search=${encodeURIComponent(item.title)}`}
                href={`/media-item/${item.id}`}
                className={`suggestion-item${index === activeIndex ? ' active' : ''}`}
                onMouseEnter={() => setActiveIndex(index)}
              >
                <img src={item.image || '/static/placeholder.jpg'} className="suggestion-thumb" alt={item.title} />
                <img src={typeIcons[item.type] || '/static/icons/question-solid.svg'} className="type-icon" alt={item.type} />
                {item.title}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBar;